export default __webpack_public_path__ + "static/media/Ciaz.858d2912.png";